exports = module.exports = require("../../../node_modules/css-loader/lib/css-base.js")(true);
// imports


// module
exports.push([module.id, "\n.Content[data-v-005b643b]{padding:10px 20px;color:var(--basicText)\n}\n.Content h2[data-v-005b643b]{font-size:20px;margin-bottom:15px\n}\n.Content p[data-v-005b643b]{font-size:16px;margin:0\n}", "", {"version":3,"sources":["/opt/front/src/components/popups/BlockPopup.vue"],"names":[],"mappings":";AACA,0BAA0B,kBAAkB,sBAAsB;CACjE;AACD,6BAA6B,eAAe,kBAAkB;CAC7D;AACD,4BAA4B,eAAe,QAAQ;CAClD","file":"BlockPopup.vue","sourcesContent":["\n.Content[data-v-005b643b]{padding:10px 20px;color:var(--basicText)\n}\n.Content h2[data-v-005b643b]{font-size:20px;margin-bottom:15px\n}\n.Content p[data-v-005b643b]{font-size:16px;margin:0\n}"],"sourceRoot":""}]);

// exports



//////////////////
// WEBPACK FOOTER
// ./node_modules/css-loader?{"sourceMap":true}!./node_modules/vue-loader/lib/style-compiler?{"vue":true,"id":"data-v-005b643b","scoped":true,"hasInlineConfig":false}!./node_modules/sass-loader/dist/cjs.js?{"sourceMap":true}!./node_modules/vue-loader/lib/selector.js?type=styles&index=0!./src/components/popups/BlockPopup.vue
// module id = M2nm
// module chunks = 40